import { render } from "./Override.vue?vue&type=template&id=0ce19fc2"
import script from "./Override.vue?vue&type=script&lang=ts"
export * from "./Override.vue?vue&type=script&lang=ts"
script.render = render

export default script